import React, { useEffect } from "react";
import {
  FaListAlt,
  FaCloudUploadAlt,
} from "react-icons/fa";
import { FiRefreshCw, FiX } from "react-icons/fi";
import { MdDashboard } from "react-icons/md";
import { useNavigate } from 'react-router-dom';

export default function LeftMenu01(props) {
  const navigate = useNavigate();
  const handleDashboard = () => {
    navigate('/dashboard/candidateDashboard');
  };
  const handleSchedule = () => {
    navigate('/candidate-schedule');
  };
  const handleApplied = () => {
    navigate('/candidate-applied');
  };
  const handleAssessment = () => {
    navigate('/candidate-assessmentHomePage');
  };
  return (
    <div className={`sidenav ${props.menuClick ? 'sidenav-toggle' : ''}`} >
      <div className="sidenav-header">
        <FiX style={{ fontSize: '20px', right: '8px', top: '8px', cursor: 'pointer' }}
          className="text-secondary opacity-50 position-absolute d-xl-none"
          onClick={() => props.closeMenu()}
        />
        {/* <a className="navbar-brand m-0" href="/" target="_blank">
          <img src={Logo} className="navbar-brand-img img-fluid d-block mx-auto" alt="main_logo" width={140} height="auto" />
        </a> */}
      </div>
      <hr className="horizontal mt-0"></hr>
      <ul className="navbar-nav sidenav-nav">
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a className="sidenav_link"
            onClick={handleDashboard}
            //href="/dashboard/candidateDashboard"
            id="ResumeUploadMenu">
            <MdDashboard title="Resume Upload" className="text-info" />
            <span>Dashboard</span>
          </a>
        </li>
        {/* <li className="nav-item">
              <a className="sidenav_link" href="/candidate-resume-upload" id="candidateresumeUpload">
                <FaCloudUploadAlt title="Resume Upload" className="text-success" />
                <span>Resume Upload</span>
              </a>
            </li> */}
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a className="sidenav_link"
            //href="/candidate-schedule"
            onClick={handleSchedule}
            id="ScheduleMenu">
            <FaListAlt title="Schedules" className="text-primary" />
            <span>Schedule </span>
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a className="sidenav_link"
            // href="/candidate-applied"
            onClick={handleApplied}
            id="AppliedMenu">
            <FiRefreshCw title="Schedules" className="text-primary" />
            <span>Applied </span>
          </a>
        </li>
        <li className="nav-item" style={{ cursor: "pointer" }}>
          <a className="sidenav_link"
            // href="/candidate-assessmentHomePage"
            onClick={handleAssessment}
            id="assessmentMenu">
            <FiRefreshCw title="Schedules" className="text-primary" />
            <span>Assessment Test</span>
          </a>
        </li>
      </ul>
    </div>
  );
}
